import styled from 'styled-components';

import { ReactComponent as UnknownResourceSvg } from 'components/icons/unknown-resource.svg';

export const StyledUnknownResource = styled(UnknownResourceSvg)`
  height: ${props => props.squareSize}rem;
  margin: auto 1rem auto 0;
  width: ${props => props.squareSize}rem;
`;
